export default {
  configManage: {
    lang: 'cn',
    dataLoadFail: '加载数据失败！',
    action: '操 作'
  }
}
